import { createNextTableContext } from '@core/table';

export const PartnerBoxesTableContext = createNextTableContext();
